import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const now: Date = new Date()
    const year: number = now.getFullYear()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, " © " + _toDisplayString(_unref(year)), 1))
}
}

})